import React, {PropTypes} from 'react';
import DatePicker from 'react-datepicker';
import './calendar.less';
import moment from 'moment';

export default class Calendar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected : ''
    }
  }
  componentDidMount(){
    if(moment(this.props.value).isValid())
    {
      this.setState({
        selected : moment(this.props.value)
      })
    }
  }
  componentWillReceiveProps(newProps){
    if(moment(newProps.value).isValid())
    {
      this.setState({
        selected : moment(newProps.value)
      })
    }
  }
  onChange = (value) =>{
    this.props.dateChangeHandler(this.props.for,value);
    this.setState({
      selected : value
    })
  }
  render() {
    return (
        <DatePicker
          includeDates={[moment(), moment().add(1, "days"),moment().add(2, "days"),moment().add(3, "days"),moment().add(4, "days"),moment().add(5, "days"),moment().add(6, "days"),moment().add(7, "days")]}
          selected = {this.state.selected}
          onChange = {this.onChange}
          placeholderText= "Select Date"/>
      )
  }
}

Calendar.propTypes = {
};



// WEBPACK FOOTER //
// app/components/calendar/calendar.jsx